var Core = {

	Auth : {

		init : function()
		{	
			$(".auth-component-login").focus();
			$(".card").css('margin-top','50px');
			$(".auth-component-btn").removeAttr('disabled'); // fix firefox
			$(".auth-component-btn").click(function(){
				Core.Auth.checkCredentials();
			});

			$(".auth-component-login, .auth-component-passwd").keyup(function(e){
				if(e.keyCode == 13 || e.charCode == 13)
					Core.Auth.checkCredentials();
			});

			$(".auth-component-save").iCheck({
			 	checkboxClass: 'icheckbox_polaris',
				radioClass: 'iradio_polaris'
			});

			$(".auth-component-forgot").click(function(){
				$(".main-login").addClass('main-hidden');
				$(".main-forgot").removeClass('main-hidden');
				$(".auth-component-forgot-login").focus();
				$(".auth-component-forgot-login").val('').removeAttr('disabled');
				$(".auth-component-forgot-email").val('').removeAttr('disabled');
				$(".auth-component-forgot-btn").button('reset');
			});

			$(".auth-component-forgot-back").click(function(){
				$(".main-forgot").addClass('main-hidden');
				$(".main-forgot-code").addClass('main-hidden');
				$(".main-forgot-changepasswd").addClass('main-hidden');
				$(".main-login").removeClass('main-hidden');
				$(".auth-component-login").focus();
			});

			$(".auth-component-forgot-code").click(function(){
				$(".main-forgot").addClass('main-hidden');
				$(".main-forgot-code").removeClass('main-hidden');
				$(".auth-component-forgot-token").focus();
			});

			$(".auth-component-forgot-login, .auth-component-forgot-email").keyup(function(e){
				if(e.keyCode == 13 || e.charCode == 13)
					Core.Auth.ForgotPasswd();
			});

			$(".auth-component-forgot-btn").click(function(){
				Core.Auth.ForgotPasswd();
			});

			$("#btn-forgot-code").click(function(){
				Core.Auth.ResetPasswd();
			});

			$(".auth-component-changepasswd-back").click(function(){
				$(".main-changepasswd").addClass('main-hidden');
				$(".main-login").removeClass('main-hidden');
				$(".main-forgot").addClass('main-hidden');
				$(".main-forgot-code").addClass('main-hidden');
				$(".auth-component-login").focus();
			});

			$(".auth-component-changepasswd-showpass").click(function(){
				if(!$(this).attr('show'))
				{
					$(".auth-component-newpasswd").attr('type','text');
					$(this).html("<span class='fa fa-asterisk'></span> Esconder Senha");
					$(this).attr('show', 1);
				} else {
					$(".auth-component-newpasswd").attr('type','password');
					$(this).html("<span class='fa fa-unlock'></span> Mostrar Senha");
					$(this).removeAttr('show');
				}
			});

		},

		checkCredentials : function()
		{
			var params = {};
			params.login = $(".auth-component-login").val();
			params.passwd = $(".auth-component-passwd").val();
			params.save = $(".auth-component-save").is(':checked') ? 1 : 0;
			params.env = $(".auth-component-btn").attr('env');

			// faz validação dos campos
			if(params.login.length < 4)
			{
				$(".auth-component-login").focus();
				$(".auth-component-login-icon").css('color','red');
				return false;
			}

			if(params.passwd.length < 6)
			{
				$(".auth-component-passwd").focus();
				$(".auth-component-passwd-icon").css('color','red');
				return false;
			}

			Core.CallAuth('CheckCredentials', params, 'json', 
			function(){
				$(".auth-component-btn").button('loading');
			}, function(r){

				if(r.response)
				{
					if(r.response == true)
						Core.ReloadPage();
					else if (r.response.changepasswd == true)
						Core.Auth.ChangePasswd(r);
					
				} else
				{
					var ohtml = $(".auth-component-btn").html();
					$(".auth-component-btn").html("Dados não conferem!").addClass('btn-danger');
					window.setTimeout(function(){
						$(".auth-component-btn").html(ohtml).removeClass('btn-danger').button('reset');
					},2500);
				}
				
			});
		},

		ForgotPasswd : function()
		{

			var params = {};
			params.login = $(".auth-component-forgot-login").val();
			params.email = $(".auth-component-forgot-email").val();
			if(params.login.length > 4 || params.email.length > 5)
			{
				$(".auth-component-forgot-login").attr('disabled','disabled');
				$(".auth-component-forgot-email").attr('disabled','disabled');
				$(".auth-component-forgot-btn").button('loading');
				Core.CallAuth('Forgot', params, 'json', null, function(r){
					if(r.response)
					{
						$(".main-forgot").addClass('main-hidden');
						$(".main-forgot-code").removeClass('main-hidden');
						$(".auth-component-forgot-token").focus();
					} else {
						$(".auth-component-forgot-login").removeAttr('disabled');
						$(".auth-component-forgot-email").removeAttr('disabled');
						$(".auth-component-forgot-btn").button('reset').html("<span class='fa fa-exclamation-triangle'></span> Usuário não encontrado!").removeClass('btn-primary').addClass('btn-warning');
						window.setTimeout(function(){
							$(".auth-component-forgot-btn").removeClass('btn-warning').addClass('btn-primary').html("<span class='fa fa-refresh'></span> Tentar novamente");
						}, 2500);						
					}
				});
			} else 
				$(".auth-component-forgot-login").focus().next('.form-control-feedback').css('color','red');
		},

		ResetPasswd : function()
		{
			var params = {};
			params.token = $(".auth-component-forgot-token").val();
			if(params.token.length == 6)
			{
				$(".auth-component-forgot-code-btn").button('loading');
				Core.CallAuth('Reset', params, 'json', null, function(r){
					if(r.response && r.response.success && r.response.newpass)
					{
						var html = "<span style='font: bold 15px arial; color: #46A820'><span class='fa fa-check-square' ></span> Senha alterada com sucesso!</span></span><br/> \
						<br/>Sua nova senha é:<br/> \
						<h2>"+r.response.newpass+"</h2>";
						$(".auth-component-forgot-reset").html(html);
					}
					else
					{
						$(".auth-component-forgot-code-btn").button('reset').removeClass('btn-primary').addClass('btn-warning').html("<span class='fa fa-exclamation-triangle'></span> Código inválido");
						window.setTimeout(function(){
							$(".auth-component-forgot-code-btn").removeClass('btn-warning').addClass('btn-primary').html("<span class='fa fa-check-square'></span> Tentar novamente");
						}, 2500);
					}
				});
			}
		},

		ChangePasswd : function(r)
		{
			$(".main-changepasswd").removeClass('main-hidden');
			$(".main-login").addClass('main-hidden');
			$(".auth-component-newpasswd").focus();
			$(".auth-component-btn").button('reset');

			$("#btn-changepasswd").unbind('click');
			$("#btn-changepasswd").click(function(){
				Core.Auth.TryChangePasswd(r.response);
			});
		},

		TryChangePasswd : function(r)
		{
			var pass1 = $(".auth-component-newpasswd").val();
			if(pass1.length > 5)
			{
				var pass2 = $(".auth-component-newpasswd2").val();
				if(pass1 == pass2)
				{
					$("#btn-changepasswd").button('loading');
					var params = {};
					params.action = 'systemusuarios/alterasenha3';
					params.user = r.user;
					params.newpasswd = pass1;
					params.save = $(".auth-component-save").is(':checked') ? 1 : 0;
					Core.CallJSON(params, function(re){
						
						if(re.response == true)
							Core.ReloadPage();
						else if(re.error)
						{
							$("#btn-changepasswd").removeClass('btn-primary').addClass('btn-danger').attr('disabled','disabled').html(re.error);
							window.setTimeout(function(){
								$("#btn-changepasswd").removeClass('btn-danger').addClass('btn-primary').removeAttr('disabled').html("<span class='fa fa-check-square'></span> Salvar nova senha");
								$("#btn-changepasswd").button('reset');
							},2500);
						}
					})
				} else {
					$("#btn-changepasswd").removeClass('btn-primary').addClass('btn-danger').attr('disabled','disabled').html('Senha devem ser iguais!');
					window.setTimeout(function(){
						$("#btn-changepasswd").removeClass('btn-danger').addClass('btn-primary').removeAttr('disabled').html("<span class='fa fa-check-square'></span> Salvar nova senha");
					},2500);
				}
			} else {
				$("#btn-changepasswd").removeClass('btn-primary').addClass('btn-danger').attr('disabled','disabled').html('Mínimo 06 caracteres!');
				window.setTimeout(function(){
					$("#btn-changepasswd").removeClass('btn-danger').addClass('btn-primary').removeAttr('disabled').html("<span class='fa fa-check-square'></span> Salvar nova senha");
				},2500);
			}
		},

		Logout : function()
		{
			Core.CallAuth('Logout', null, 'json', null, function(){ window.location = window.location.href; });
		}

	},

	Actioner : {

		count : 0,

		init : function()
		{
			$(".actioner-component[fn]").each(function(){
				var fn = $(this).attr('fn');
				
				if (typeof fn !== 'undefined')
				{
					$(this).removeAttr('fn');

					var id = "actioner-"+Core.Actioner.count;
					$(this).attr('id', id);

					// Attach this
					fn = fn.replace("({","({aid:'"+id+"',");
					$(this).click(function(){
						eval(fn);
					});

					Core.Actioner.count++;
				}
			});
		}

	},

	CallAuth : function(fn, params, format, callinit, callback)
	{

		format = typeof format !== 'undefined' ? format : 'json'; // ACCEPT JSON || HTML

		var obj = {};
		obj.fn = fn;
		obj.params = params;
		obj.format = format;

		if(typeof callinit === 'function')
			callinit();
		
		$.post("/P5fw/auth", obj, function(r)
		{
			if(typeof callback == 'function')
				callback(r);

		},format);

	},

	CallJSON : function(params, callback)
	{
		$.post("/P5fw/acmanager", params, function(r){
			if(typeof callback === 'function')
				callback(r);
		},'json');
	},

	ReloadPage : function()
	{
		window.location = window.location.href;
	},

	Serialize : function(obj)
	{
		var str = [];
		for(var p in obj)
		    if (obj.hasOwnProperty(p)) {
		    	str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
		    }
		return str.join("&");
	}

}

// -- INIT EVENT HANDLERS
$(function(){

	// Auth
	Core.Auth.init();

})